import { Module } from 'vuex'
import { mapValues, get } from 'lodash'

import { Http } from '@/api'
import { RootState } from '@/store/types'


const namespaced: boolean = true

export const event: Module<{}, RootState> = {
  namespaced,
  actions: {
    lookupEmailContact: (
      { commit, rootGetters },
      { contact, fields }: { contact: string, fields: Record<string, string> }
    ) => {
      contact = rootGetters['context/getVariable'](contact)
      const resource = `api/permissions/${contact}?contact_type=email`
      return Http.get(resource).then(
        data => {
          const variables = mapValues(fields, get.bind(null, data))
          commit('context/setVariables', { variables }, { root: true })
        }
      )
    },
    lookupPhoneContact: (
      { commit, rootGetters },
      { contact, fields }: { contact: string, fields: Record<string, string> }
    ) => {
      contact = rootGetters['context/getVariable'](contact)
      const resource = `api/permissions/${contact}?contact_type=phone`
      return Http.get(resource).then(
        data => {
          const variables = mapValues(fields, get.bind(null, data))
          commit('context/setVariables', { variables }, { root: true })
        }
      )
    },
    lookupPhoneType: (
      { commit, rootGetters },
      { contact, fields, companyCode }: {
        contact: string,
        fields: Record<string, string>,
        companyCode: string
      }
    ) => {
      contact = rootGetters['context/getVariable'](contact)
      const resource = `api/webforms/${companyCode}/phone/${contact}`
      return Http.get(resource).then(
        data => {
          const variables = mapValues(fields, get.bind(null, data))
          commit('context/setVariables', { variables }, { root: true })
        }
      )
    }
  }
}
